import {Component,Inject,OnInit} from '@angular/core';
import {MAT_DIALOG_DATA,MatDialogConfig,MatDialogRef} from '@angular/material/dialog';
import {WebClient} from '@injectables';
import {op} from '@lib/rxjs';
import {Client,Device,User,Site} from '@models';
import { FragQueryService } from 'src/injectables/frag-query.service';

interface Input{
	record:Device;
}

@Component({
	selector: 'device-edit-dialog',
	templateUrl: './device-edit-dialog.component.html',
	styleUrls: [
		'./device-edit-dialog.component.scss'
	]
})
export class DeviceEditDialog implements OnInit{
	static readonly config:MatDialogConfig<Input>={
		autoFocus: false,
		disableClose: true,
	};
	static readonly output:boolean;

	constructor(
		public readonly user:User,
		private readonly fragQuery:FragQueryService,
		private readonly webClient:WebClient,
		private host:MatDialogRef<boolean>,
		@Inject(MAT_DIALOG_DATA) private readonly input:Input,
	){
	}
	public loadingClients = true;
	public loadingSites = false;
	public readonly quantityUnitSystem$ = this.fragQuery.QuantityUnitSystem$;
	public readonly particleSizeUnitSystem$ = this.fragQuery.particleSizeUnitSystem$;
	public readonly clients$=this.webClient.model.client.search$({}).pipe(
		op.tap(() => this.loadingClients = false),
		op.startWith([]));
	public readonly initialClient$=this.clients$
		.pipe(op.map(clients=>clients.find(client=>client.id===this.record.clientId)));
	
	// Initial sites for the record's client
	public readonly initialSite$ = this.webClient.model.site
		.search$({ where: { clientId: this.input.record.clientId } })
		.pipe(
			op.tap(() => this.loadingSites = false),
			op.startWith([] as Site[])
		);

    // siteOptions and selection
	public siteOptions: Site[] = [];
	public siteId = this.input.record.siteId;

	public record=this.input.record;
	public client:Client;
	public name=this.record.name ?? '';
	public type=this.record.type;
	public notes=this.record.notes ?? '';
	public threshold=this.record.threshold ?? 0;
	public slabDiameter=this.record.slabDiameter ?? 0;
	public alertEmail=this.record.alertEmail ?? '';
	public density=this.record.density;

	public readonly typeOptions=Object.entries(Device.typeOptions);

	public ngOnInit() {
		this.initialSite$.subscribe((sites) => {
			this.siteOptions = sites;
		});

		this.clients$
			.pipe(op.map((cs) => cs.find((c) => c.id === this.record.clientId)))
			.subscribe((client) => {
				this.client = client;
			});
	}

	public clientDisplayWith(client:Client){
		return client?.name ?? '';
	}

	public onClientSelected(client: Client): void {
		this.client = client;
		this.siteId = null!;
		this.loadingSites = true;
		// load sites for chosen client
		this.webClient.model.site
			.search$({ where: { clientId: client.id } })
			.subscribe((sites) => {
				this.siteOptions = sites;
				this.loadingSites = false;
			});
	}

	public valid(){
		if(!this.client||!this.client.id)	
			return false;
		if(!this.name)
			return false;
		return true;
	}

	public cancel(){
		this.host.close(false);
	}
	
	public save(){
		this.record.clientId=this.client.id;
		this.record.siteId = this.siteId;
		this.record.name=this.name;
		this.record.type=this.type;
		this.record.notes=this.notes;
		this.record.threshold=this.threshold;
		this.record.slabDiameter=this.slabDiameter;
		this.record.alertEmail=this.alertEmail;
		this.record.density=this.density;
		this.host.close(true);
	}
}
